<template>
  <div class="container main-content">
    <h2>Contacts</h2>
    <div class="row boxes-row">
      <div class="col-lg-3" v-for="box in boxes" :key="box.idTeamMember">
        <TeamMemberBox :box="box" />
      </div>
    </div>
  </div>
</template>

<script>
import TeamMemberBox from "@/components/persons/TeamMemberBox";
export default {
  name: "SolutionContacts",
  components: {TeamMemberBox},
  computed: {
    boxes() {
      return this.$store.getters.solutionContacts
    }
  },
  mounted() {
    window._paq.push(['setDocumentTitle', this.$store.getters.solution.headline + ' | ' + 'Contacts']);
    window._paq.push(['trackPageView']);
  }
}
</script>
